package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config

import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.model.general.TitleEnum
import org.hs_soft.runmynesto.domain.util.helper.Strings

enum class CashRegisterTypeEnum(val value: String) : TitleEnum {
    ADD_NEW_BUSINESS_OFFICE(
        value = ""
    ),
    ADD_NEW_REGION(
        value = ""
    ),
    ADD_NEW_BRANCH(value=""
    ),
    ADD_NEW_CASH_REGISTER(
        value = ""
    );

    @Composable
    fun getTitle(): String {
        val strings = Strings.current()
        return when (this) {
            ADD_NEW_BUSINESS_OFFICE -> strings.addNewBusinessOfficeDE
            ADD_NEW_REGION -> strings.addNewRegionDE
            ADD_NEW_BRANCH -> strings.addNewBranchDE
            ADD_NEW_CASH_REGISTER -> strings.addNewCashRegisterDE
        }
    }

    override val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                ADD_NEW_BUSINESS_OFFICE -> strings.addNewBusinessOfficeDE
                ADD_NEW_REGION -> strings.addNewRegionDE
                ADD_NEW_BRANCH -> strings.addNewBranchDE
                ADD_NEW_CASH_REGISTER -> strings.addNewCashRegisterDE
            }
        }
}